var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/App Icon/iTunesArtwork") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E3E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABB3B3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets/App-Icon/iTunesArtwork"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    opacity: 0.5,
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L512,512 M512,0 L0,512",
    id: "Diagonal",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,0 L33,512 M159,0 L159,512 M256,0 L256,512 M353,0 L353,512 M479,0 L479,512",
    id: "Vertical",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,479 L512,479 M0,353 L512,353 M0,256 L512,256 M0,159 L512,159 M0,33 L512,33",
    id: "Horizontal",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,479 C379.159499,479 479,379.159499 479,256 C479,132.840501 379.159499,33 256,33 C132.840501,33 33,132.840501 33,256 C33,379.159499 132.840501,479 256,479 Z M256,393 C331.663011,393 393,331.663011 393,256 C393,180.336989 331.663011,119 256,119 C180.336989,119 119,180.336989 119,256 C119,331.663011 180.336989,393 256,393 Z M256,353 C309.571621,353 353,309.571621 353,256 C353,202.428379 309.571621,159 256,159 C202.428379,159 159,202.428379 159,256 C159,309.571621 202.428379,353 256,353 Z",
    id: "Rings"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppPlaceholder);
export default __webpack_public_path__ + "static/media/app_placeholder.595b1d2cc32e1e6f584a289083b98ab0.svg";
export { ForwardRef as ReactComponent };